export default __webpack_public_path__ + "locales/sl/ConnectDialog.json?hash=c5bb8363da9cecf3b1ebc3daed28235c";